<template>
  <v-dialog v-model="dialog" width="650" persistent>
    <v-card flat style="height: 100% !important;">
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title>Pilih Sekolah rentang nilai PKP 0 - 50</v-toolbar-title>
        <v-spacer />
        <v-btn text icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-container>
        <base-table-header
          :search-input="false"
          :btn-reload="false"
          @search="onSearch"
          @reload="onReload"
          :options="{ header: 'py-0' }"
        >
          <template v-slot:subtitle>
            <div class="my-auto body-2 black--text"> {{ total }} Data Sekolah </div>
          </template>
        </base-table-header>
        <div style="max-height: 350px; overflow-y: auto">
          <base-list-table :hideHeader="true" :loading="loading" :item="data" :total="total" :usePaging="false">
            <template slot-scope="{ item, index }">
              <td>
                <v-list-item dense class="px-0" :key="index">
                  <v-list-item-avatar color="secondary">
                    <v-icon dark>mdi-home</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <div class="blue--text">{{ item.nama }}</div>
                    <div><strong>NPSN: </strong> {{ item.npsn }}</div>
                    {{ item.sekolah_id }}
                  </v-list-item-content>
                  <v-list-item-action-text>
                    <v-checkbox :value="item.sekolah_id" v-model="selected"></v-checkbox>
                  </v-list-item-action-text>
                </v-list-item>
              </td>
            </template>
          </base-list-table>
        </div>
        <base-table-footer :pageTotal="pageTotal" @changePage="onChangePage" />
        <v-divider class="mb-3 mt-7" />
        <div class="text-right">
          <v-btn color="success" :disabled="!selected.length" depressed @click="onSelect">Pilih Sekolah</v-btn>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import list from '@mixins/list';
import { mapActions } from 'vuex';

export default {
  mixins: [list],
  props: {
    kpPaId: {
      type: [Number, String],
    },
  },
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      selected: [],
      sekolahs: {},
      total: 0,
    };
  },
  methods: {
    ...mapActions('lokakaryaPa', ['sekolah']),

    fetchData() {
      const id = this.kpPaId;
      const params = Object.assign(this.params, this.$isObject(this.filters) ? this.filters : {});

      this.sekolah({ id, params }).then((data) => {
        this.data = data || [];
        this.sekolahs = this.$arrToObj(this.data, 'sekolah_id');
        this.total = this.data.length;
        this.pageTotal = 1;
        this.params.limit = 20;
      });
    },

    open(sekolahs) {
      this.selected = sekolahs.map((sekolah) => {
        return sekolah.sekolah_id;
      });
      this.dialog = true;
      this.data = [];
      this.fetchData();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    onSelect() {
      const selected = this.selected.map((sekolahId) => {
        return this.sekolahs[sekolahId] || {};
      });

      this.resolve(selected);
      this.dialog = false;
    },
  },
};
</script>
<style scoped>
.v-radio {
  display: block !important;
}
</style>
